import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { ISalesByProductApiService } from './sales-by-product-api.interface';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportSalesByProductQueryDto } from './dtos/export-sales-by-product.query.dto';
import { FindSalesByProductQueryDto } from './dtos/find-sales-by-product.query.dto';
import { FindSalesByProductResponseDto } from './dtos/find-sales-by-product.response.dto';

@Injectable({
  providedIn: 'root',
})
export class SalesByProductApiService implements ISalesByProductApiService {
  private readonly ENDPOINT = 'products';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findSalesByProduct(
    query: FindSalesByProductQueryDto
  ): Promise<FindSalesByProductResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindSalesByProductResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportSalesByProduct(
    query: ExportSalesByProductQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}

